import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import ko from "date-fns/locale/ko";
import { useParams } from "react-router-dom";
import { useFormInput, dateFormat, dateFormatDateTime, calculateAge, validateCarYear, maskName, calculateInsuranceAge } from "@/utils";
import {
    useGetCarGubunQuery,
    useGetCarManufacturerQuery,
    useGetCarModelQuery,
    useGetCarModelDetailQuery,
    useGetCarClassQuery,
    useGetCarTrimQuery,
    useGetFuelListQuery,
} from "@/redux/metaApi";
import {
    originOptions,
    orderTypeOptions,
    orderMethodOptions,
    chargeMethodOptions,
    expectFaultOptions,
    orderSubStatusOption,
    displacementOptions,
} from "@/constants/selectOptions";

import { Loading, Toast, Confirm } from "@/components";
import SearchAddress from "@/components/Modal/Common/SearchAddress";
import Select from "react-select";

import refreshIcon from "@/assets/icons/refresh.svg";
import sendIcon from "@/assets/icons/send.svg";
import { useGetOrderDetailMutation, usePutModifyOrderMutation, useGetOrderChatMutation, usePostOrderChatMutation } from "@/redux/orderApi";
import { useGetContractGroupListQuery } from "@/redux/contractApi";
import { rolesOptions } from "../../constants/selectOptions";
import {formatPhoneNumber} from "../../utils";

export const OrderDetail = () => {
    const navigate = useNavigate();
    const { orderId } = useParams();
    const [getOrderDetail, { data: detailData, isLoading: detailIsLoading, error: detailError }] = useGetOrderDetailMutation();
    const [putModifyOrder, { data: modifyData, isLoading: modifyIsLoading, error: modifyError }] = usePutModifyOrderMutation();
    const [getOrderChat] = useGetOrderChatMutation();
    const [postOrderChat] = usePostOrderChatMutation();
    const { data: contractGroupList, refetch } = useGetContractGroupListQuery({ order_id: orderId }, { skip: !orderId });

    const previewRef = useRef(null);
    const messageInputRef = useRef(null);
    const [chatList, setChatList] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        getOrderDetail(orderId);
    }, [orderId]);

    const { formData, handleChange, setFormData } = useFormInput({
        // 공통
        mode: "CREATE", // "CREATE" / "READ" / "UPDATE"
        toastMsg: "",
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        partnersPopupStatus: false,
        addressPopupStatus: false,

        selectedPartnerName: "",
        insuranceAgeOptions: [
            { value: "OVER21", label: "만 21세 이상" },
            { value: "OVER26", label: "만 26세 이상" },
        ],

        // GET API
        id: "",
        orderMember: {
            id: "",
            writerId: "",
            loginId: "",
            password: "",
            email: "",
            snsId: "",
            name: "",
            birthDate: "",
            phone: "",
            idNumber: "",
            memberStatus: "",
            mobileType: "",
            accessAbleYn: "",
            leavedAt: "",
            accountType: "",
            point: 0,
            accessToken: "",
            refreshToken: "",
            lastAccessedAt: "",
            roles: [],
            updatedAt: "",
            createdAt: "",
            createdId: "",
            lastModifiedId: "",
        },
        orderNumber: "",
        orderMemberId: "",
        obtainRentCorpId: "",
        obtainMemberId: "",
        orderType: "",
        orderMethod: "",
        orderStatus: "",
        orderSubStatus: "",
        carNumber: "",
        carGubun: "",
        manufacturerName: "",
        modelName: "",
        modelDetailName: "",
        className: "",
        trimName: "",
        cho: "",
        bmNo: "",
        boiNo: "",
        boNo: "",
        bsNo: "",
        bdNo: "",
        displacement: "",
        year: "",
        version: "",
        orderBusinessCorp: {
            corpName: "",
            businessNumber: "",
            managerName: "",
            managerPhone: "",
            email: "",
            bCode: "",
            address: "",
            addressDetail: "",
            bcode: "",
        },
        orderCustomer: {
            id: "",
            name: "",
            phone: "",
            location1AddressCodeId: "",
            location1AddressCode: {},
            location2AddressCodeId: "",
            location2AddressCode: {},
            birthDate: "",
            updatedAt: "",
            createdAt: "",
            createdId: "",
            lastModifiedId: "",
        },
        orderInsurance: {
            id: "",
            insuranceCorpName: "",
            receiptNumber: "",
            expectFault: "",
            expectCommission: "",
            updatedAt: "",
            createdAt: "",
            createdId: "",
            lastModifiedId: "",
        },
        orderMechanic: {
            id: "",
            mechanicCorpName: "",
            phone: "",
            address: "",
            addressDetail: "",
            bCode: "",
            updatedAt: "",
            createdAt: "",
            createdId: "",
            lastModifiedId: "",
        },
        orderCharge: {
            id: "",
            chargeMethod: "",
            chargeRate: "",
            memo: "",
            updatedAt: "",
            createdAt: "",
            createdId: "",
            lastModifiedId: "",
        },
        updatedAt: "",
        createdAt: "",

        releasedAt: "",
        returnedDate: "",
        assignCarInfo: "",
        memoForTime: "",
    });

    const {
        mode,
        toastMsg,
        confirmStatus,
        partnersPopupStatus,
        addressPopupStatus,
        selectedPartnerName,
        insuranceAgeOptions,
        // GET API
        id,
        orderMember,
        orderNumber,
        orderMemberId,
        obtainRentCorpId,
        obtainMemberId,
        orderType,
        orderMethod,
        orderStatus,
        orderSubStatus,
        carNumber,
        carGubun,
        manufacturerName,
        modelName,
        modelDetailName,
        className,
        trimName,
        cho,
        bmNo,
        boiNo,
        boNo,
        bsNo,
        bdNo,
        displacement,
        version,
        orderBusinessCorp,
        orderCustomer,
        orderInsurance,
        orderMechanic,
        orderCharge,
        updatedAt,
        createdAt,

        releasedAt,
        returnedAt,
        assignCarInfo,
        memoForTime,
    } = formData;

    useEffect(() => {
        detailData?.data &&
            setFormData((prev) => {
                const errorMsg = validateCarYear(detailData.data.year);
                return {
                    ...prev,
                    ...detailData?.data,
                    toastMsg: errorMsg || prev.toastMsg,
                };
            });
    }, [detailData]);

    const showConfirm = (title, description, buttons) => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: {
                confirmPopupStatus: true,
                confirmTitle: title,
                confirmDescription: description,
                confirmButtons: buttons,
            },
        }));
    };

    const handleDeleteConfirm = async () => {
        try {
            showConfirm("삭제가 완료되었습니다.", "", [
                {
                    label: "확인",
                    className: "btn-primary",
                    onClick: () =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        })),
                },
            ]);
        } catch (error) {
            console.error("Failed to delete vehicle:", error);
        }
    };

    const handleDelete = () => {
        showConfirm(`해당 차량 정보를 삭제하시겠습니까?`, "삭제 후에는 복구할 수 없습니다.", [
            { label: "예", className: "btn-primary", onClick: handleDeleteConfirm },
            {
                label: "아니오",
                className: "btn-cancel",
                onClick: () =>
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: { confirmPopupStatus: false },
                    })),
            },
        ]);
    };

    const handleSaveConfirm = async () => {
        setFormData((prev) => ({
            ...prev,
            confirmStatus: { confirmPopupStatus: false },
        }));
        const actionText = mode === "CREATE" ? "등록" : "수정";

        try {
            const vehicleDataToSave = {};

            showConfirm(`${actionText}이 완료되었습니다.`, "", [
                {
                    label: "확인",
                    className: "btn-primary",
                    onClick: () =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        })),
                },
            ]);
        } catch (error) {
            // setFormData((prev) => ({ ...prev, toastMsg: error?.message || "에러 발생" }));
            console.error(`Failed to ${actionText} vehicle:`, error);
        }
    };

    const handleSave = () => {
        const actionText = mode === "CREATE" ? "등록" : "수정";

        const modifyBody = {
            orderId: id,
            orderType,
            orderMethod,
            rentCorpId: obtainRentCorpId,
            carNumber,
            cho,
            carGubun,
            bmNo,
            boiNo,
            boNo,
            bsNo,
            bdNo,
            displacement,
            releasedAt,
            returnedAt,
            memoForTime,
            orderBusinessCorp,
            orderCustomer,
            orderInsurance,
            orderCharge,
            orderMechanic,
        };

        showConfirm(`오더 정보를 수정 하시겠습니까?`, "", [
            {
                label: "예",
                className: "btn-primary",
                onClick: async () => {
                    const res = await putModifyOrder(modifyBody);
                    res.error &&
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                            toastMsg: res.error?.message,
                        }));

                    res.data &&
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                            toastMsg: "수정되었습니다.",
                        }));

                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: { confirmPopupStatus: false },
                    }));
                },
            },
            {
                label: "아니오",
                className: "btn-cancel",
                onClick: () =>
                    setFormData((prev) => ({
                        ...prev,
                        confirmStatus: { confirmPopupStatus: false },
                    })),
            },
        ]);
    };

    // 오더 채팅
    const scrollToBottom = () => {
        if (previewRef.current) {
            previewRef.current.scrollTop = previewRef.current.scrollHeight;
        }
    };

    const fetchChatList = async () => {
        try {
            const res = await getOrderChat(orderId).unwrap();
            setChatList(res.data);
            setTimeout(scrollToBottom, 100);
        } catch (error) {
            console.error("채팅 내역 불러오기 실패:", error);
        }
    };

    useEffect(() => {
        fetchChatList();
    }, [orderId]);

    const handleRefreshChat = () => {
        fetchChatList();
    };

    const handleMessageChange = (e) => {
        setMessage(e.target.value);
    };

    const handleSendMessage = async () => {
        if (!message.trim()) return;
        try {
            await postOrderChat({ orderId, content: message }).unwrap();
            setMessage("");
            fetchChatList();
        } catch (error) {
            console.error("메시지 전송 실패:", error);
        }
    };

    // 연속된 동일 사용자 채팅 그룹화
    function groupChatMessages(chats) {
        if (!chats || !chats.length) return [];

        let grouped = [];
        let currentGroup = {
            type: chats[0].myChatYn,
            writerId: chats[0].writerId,
            chatRole: chats[0].chatRole,
            writer: chats[0].writer,
            rentCorp: chats[0].rentCorp,
            messages: [chats[0]],
        };

        for (let i = 1; i < chats.length; i++) {
            const chat = chats[i];
            if (chat.myChatYn === currentGroup.type && chat.writerId === currentGroup.writerId && chat.chatRole === currentGroup.chatRole) {
                currentGroup.messages.push(chat);
            } else {
                grouped.push(currentGroup);
                currentGroup = {
                    type: chat.myChatYn,
                    writerId: chat.writerId,
                    chatRole: chat.chatRole,
                    writer: chat.writer,
                    rentCorp: chat.rentCorp,
                    messages: [chat],
                };
            }
        }
        grouped.push(currentGroup);

        return grouped;
    }

    // 채팅 내역 렌더링
    const renderChatMessages = () => {
        const groupedChats = groupChatMessages(chatList);

        return (
            <>
                {groupedChats.map((group, groupIndex) => {
                    const isOwn = group.type === "Y";
                    const lastMsg = group.messages[group.messages.length - 1];

                    return (
                        <div key={`group-${groupIndex}`} className={`chat-box ${isOwn ? "own" : "other"}`}>
                            {group.messages.map((msg) => (
                                <div key={msg.id} className="chat">
                                    <p className="chat-content">{msg.content}</p>
                                </div>
                            ))}

                            <div className="chat-info">
                                {!isOwn && (
                                    <div className="user">
                                        <div className="user-profile">
                                            {group.chatRole === "ORDER"
                                                ? "요청자"
                                                : group.chatRole === "ADMIN"
                                                ? "관리자"
                                                : group.chatRole === "OBTAIN"
                                                ? group.rentCorp?.corpName
                                                : "익명"}
                                        </div>
                                        <div className="user-name">
                                            {group.chatRole === "ORDER"
                                                ? "요청자"
                                                : group.chatRole === "ADMIN"
                                                ? "관리자"
                                                : group.chatRole === "OBTAIN"
                                                ? group.rentCorp?.corpName
                                                : "익명"}
                                        </div>
                                    </div>
                                )}
                                <div className="datetime">
                                    <span className="time">{new Date(lastMsg.createdAt).toLocaleString("ko-KR")}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };

    // 계약서 바로가기 핸들러
    const handleGoToContract = async () => {
        const response = await refetch();
        const contract = response.data?.data?.find((item) => item.exposedYn === "Y");
        if (contract) {
            navigate(`/contract/detail/${contract.id}`);
        } else {
            setFormData((prev) => ({ ...prev, toastMsg: "작성된 계약서가 없습니다." }));
        }
    };

    // 청구 바로가기 핸들러
    const handleGoToBilling = () => {
        console.log(formData.orderInsurance?.receiptNumber);
        if (formData.orderInsurance?.receiptNumber) {
            console.log(`/billing/status?page=0&size=20&query=${formData.orderInsurance.receiptNumber}`);
            navigate(`/billing/status?page=0&size=20&query=${formData.orderInsurance.receiptNumber}`);
        } else {
            setFormData((prev) => ({ ...prev, toastMsg: "보험접수번호가 없습니다." }));
        }
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management-form container">
                <div className="form-container">
                    <div className="form-head">
                        <div className="head-tit">
                            <span className="form_name">요청내역 상세보기</span>
                            <span className="form_desc"></span>
                        </div>
                        <div className="head-options">
                            <button type="button" className="btn btn-outline" onClick={() => navigate(-1)}>
                                이전으로
                            </button>
                            {mode !== "CREATE" && (
                                <>
                                    <button type="button" className="btn btn-delete" onClick={handleDelete}>
                                        오더 삭제
                                    </button>
                                </>
                            )}
                            <button type="button" className="btn btn-fourth" onClick={handleGoToContract}>
                                계약서 바로가기
                            </button>
                            <button type="button" className="btn btn-fourth" onClick={handleGoToBilling}>
                                청구 바로가기
                            </button>
                            {formData.myMatchedOrderYn === "Y" && (
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => navigate("/contract/register", { state: { orderId: formData.id } })}
                                >
                                    계약서 등록
                                </button>
                            )}
                            {/* <button type="button" className="btn btn-save" onClick={handleSave}>
                                저장
                            </button> */}
                        </div>
                    </div>

                    <div className="form-content">
                        <div className="form-wrapper">
                            <div className="order-detail-info" style={{ padding: "0" }}>
                                <div className="info-content" style={{ padding: "20px" }}>
                                    <div className="detail-process">
                                        <div className="process-list">
                                            <div className={`item ${formData.orderSubStatus === "PENDING" ? "active" : ""}`}>
                                                <span className="item-num">1</span>
                                                <span className="item-txt">매칭중</span>
                                            </div>
                                            <div
                                                className={`item ${
                                                    ["SELECTED", "CUSTOMER_CHECK", "MATCHED"].includes(formData.orderSubStatus)
                                                        ? "active"
                                                        : ""
                                                }`}
                                            >
                                                <span className="item-num">2</span>
                                                <span className="item-txt">매칭완료</span>
                                            </div>
                                            <div
                                                className={`item ${
                                                    ["CONTRACT_ING", "CONTRACT_FINISH", "DELIVERY_ING"].includes(formData.orderSubStatus)
                                                        ? "active"
                                                        : ""
                                                }`}
                                            >
                                                <span className="item-num">3</span>
                                                <span className="item-txt">배차준비</span>
                                            </div>
                                            <div className={`item ${formData.orderSubStatus === "DELIVERY_FINISH" ? "active" : ""}`}>
                                                <span className="item-num">4</span>
                                                <span className="item-txt">배차완료</span>
                                            </div>
                                            <div className={`item ${formData.orderSubStatus === "RETURN_FINISH" ? "active" : ""}`}>
                                                <span className="item-num">5</span>
                                                <span className="item-txt">반납완료</span>
                                            </div>
                                            <div className={`item ${formData.orderSubStatus === "CHARGE_FINISH" ? "active" : ""}`}>
                                                <span className="item-num">6</span>
                                                <span className="item-txt">청구완료</span>
                                            </div>
                                            <div className={`item ${formData.orderSubStatus === "FINISH" ? "active" : ""}`}>
                                                <span className="item-num">7</span>
                                                <span className="item-txt">계약종결</span>
                                            </div>
                                        </div>
                                        {/* 취소 상태 표시 */}
                                        {(formData.orderSubStatus === "REQUEST_CANCEL" || formData.orderSubStatus === "ORDER_CANCEL") && (
                                            <div
                                                style={{
                                                    marginTop: "16px",
                                                    padding: "12px",
                                                    backgroundColor: "#fff5f5",
                                                    border: "1px solid #fed7d7",
                                                    borderRadius: "8px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        color: "#e53e3e",
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    {formData.orderSubStatus === "REQUEST_CANCEL"
                                                        ? "요청이 취소되었습니다"
                                                        : "배차가 취소되었습니다"}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="detail-summary">
                                        <div className="summary-info">
                                            <span className="insurance-type">
                                                {orderTypeOptions.find((e) => e.value === orderType)?.label}
                                            </span>
                                            <span className="insurance-type">{orderInsurance.receiptNumber}</span>

                                            <span className="insurance-type">
                                                {
                                                    formData.serialNumber || ""
                                                }
                                            </span>

                                            <span className="insurance-type">
                                                {
                                                    orderInsurance.insuranceCorpName || ""
                                                }
                                            </span>
                                        </div>
                                        <div className="order-status">
                                            {orderSubStatusOption.find((e) => e.value === orderSubStatus)?.label}
                                        </div>
                                    </div>
                                    {/*<div className="detail-info">*/}
                                    {/*    <div className="info-item">*/}
                                    {/*        <div className="item-date">담당자: 김스크(010-3574-5842)???</div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">오더자 회원구분</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <OrderMemberInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            {formData.myOrderedOrderYn === "Y" ? (
                                <div className="form-item">
                                    <div className="item-head">
                                        <span className="form-item_tit">배정 업체 정보</span>
                                        <div className="form-item_etc"></div>
                                    </div>
                                    <div className="item-body">
                                        <div className="item-list">
                                            <ContractorInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">고객(운전자) 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <DriverInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">차량 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <VehicleInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">보험 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <InsuranceInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">공업사 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <WorkshopInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">배차/반납 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <ReturnInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">고객 요청사항</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <EtcInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-wrapper">
                            <div className="form-chat">
                                <div className="chat-header">
                                    <div className="user-list">
                                        <div className="user">
                                            <div className="user-profile">Mobilicar</div>
                                            <div className="user-name">모빌리카</div>
                                        </div>
                                    </div>

                                    <button type="button" className="btn-refresh" onClick={handleRefreshChat}>
                                        <img src={refreshIcon} alt="채팅 새로고침" />
                                    </button>
                                </div>

                                <div class="preview-content" ref={previewRef}>
                                    <div class="content-chat">{renderChatMessages()}</div>
                                    <div className="input-chat">
                                        <div className="item-input">
                                            <input
                                                type="text"
                                                placeholder="메세지를 입력하세요."
                                                name="message"
                                                value={message}
                                                onChange={handleMessageChange}
                                                ref={messageInputRef}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        handleSendMessage();
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="item-buttons">
                                            <button type="button" className="btn btn-input" onClick={handleSendMessage}>
                                                <span className="btn-img">
                                                    <img src={sendIcon} alt="전송" />
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirm 팝업 */}
            {confirmStatus.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}

            {/* 주소 검색 팝업 */}
            {addressPopupStatus && (
                <SearchAddress
                    modalStatus={addressPopupStatus}
                    setModalStatus={() =>
                        setFormData((prev) => ({
                            ...prev,
                            addressPopupStatus: false,
                        }))
                    }
                    setAddress={(data) =>
                        setFormData((prev) => ({
                            ...prev,
                            orderMechanic: {
                                ...orderMechanic,
                                address: data.address,
                                bcode: data.bcode,
                                bCode: data.bcode,
                            },
                        }))
                    }
                />
            )}

            {partnersPopupStatus && (
                <PartnersPopup
                    layer={true}
                    onClose={() => setFormData((prev) => ({ ...prev, partnersPopupStatus: false }))}
                    formData={formData.productItemType}
                    handleChange={handleChange}
                    setFormData={setFormData}
                />
            )}
        </>
    );
};

/* 차량 정보 */
const VehicleInfo = ({ formData, handleChange, setFormData }) => {
    const { carNumber, cho, manufacturerName, carGubun, modelName, modelDetailName, className, trimName, displacement, year } = formData;

    return (
        <>
            {/* 차량번호 */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>차량번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="carNumber" value={carNumber ?? "-"} disabled />
                    </div>
                </div>
            </div>

            {/* 국산/수입 선택 */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>국산/수입</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="cho" value={originOptions.find((e) => e.value === cho)?.label ?? cho ?? "-"} disabled />
                    </div>
                </div>
            </div>

            {/* 차종 (독립) */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>차종</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="carGubun" value={carGubun ?? "-"} disabled />
                    </div>
                </div>
            </div>

            {/* 제조사 (독립; 제조사 선택 시 하위 초기화) */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>제조사</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="manufactureName" value={manufacturerName ?? "-"} disabled />
                    </div>
                </div>
            </div>

            {/* 모델 (제조사 선택에 종속) */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>모델</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="modelDetailName" value={modelDetailName ?? "-"} disabled />
                    </div>
                </div>
            </div>

            {/* 상세모델 (모델 선택에 종속) */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>상세모델</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="modelName" value={modelName ?? "-"} disabled />
                    </div>
                </div>
            </div>

            {/* 등급 (상세모델 선택에 종속) */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>등급</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="className" value={className ?? "-"} disabled />
                    </div>
                </div>
            </div>

            {/* 트림 (등급 선택에 종속) */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>트림</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="trimName" value={trimName ?? "-"} disabled />
                    </div>
                </div>
            </div>

            {/* 배기량 */}
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>배기량(cc)</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="displacement"
                            value={displacementOptions.find((e) => e.value === displacement)?.label ?? "-"}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2"></div>
        </>
    );
};

/* 고객 정보 */
const DriverInfo = ({ formData, handleChange, setFormData }) => {
    const { orderCustomer, orderMethod } = formData;

    return (
        <>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>고객 이름</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" value={orderCustomer?.name} disabled />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>연락처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" value={formatPhoneNumber(orderCustomer?.phone|| "")} disabled />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>이용 지역</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" value={orderCustomer?.location1AddressCode?.name} disabled />
                    </div>
                    <div className="form-element">
                        <input type="text" value={orderCustomer?.location2AddressCode?.name} disabled />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>요청 방식</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="vehicleNo"
                            value={orderMethodOptions?.find((e) => e.value === orderMethod)?.label ?? "-"}
                            onChange={handleChange}
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>생년월일</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" value={orderCustomer?.birthDate} disabled />
                    </div>
                    {/* <div className="form-element">
                        <input type="text" name="" placeholder="" value={calculateAge(new Date(orderCustomer?.birthDate))} disabled />
                    </div> */}
                </div>
            </div>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>보험 나이</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" value={calculateInsuranceAge(orderCustomer?.birthDate)} disabled />
                    </div>
                </div>
            </div>
        </>
    );
};

/* 공업사 정보 */
const WorkshopInfo = ({ formData, handleChange, setFormData }) => {
    const { orderMechanic } = formData;

    const workshopOptions = [
        { value: "공업사1", label: "공업사1" },
        { value: "공업사2", label: "공업2" },
    ];

    return (
        <>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>업체명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderMechanic.mechanicCorpName"
                            value={orderMechanic?.mechanicCorpName ?? "-"}
                            placeholder=""
                            onChange={handleChange}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>연락처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderMechanic.phone"
                            value={orderMechanic?.phone ?? "-"}
                            placeholder=""
                            onChange={handleChange}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>주소</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            placeholder=""
                            name="orderMechanic.addressDetail"
                            value={(orderMechanic?.address ?? "-") + " " + (orderMechanic?.addressDetail ?? "")}
                            onChange={handleChange}
                            readOnly
                            disabled
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

/* 배차/반납 정보 */
const ReturnInfo = ({ formData, handleChange, setFormData }) => {
    const { releasedAt, returnedAt, memoForTime, contractCar } = formData;

    return (
        <>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>배차일시</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="releasedAt" value={releasedAt ?? "-"} onChange={handleChange} disabled />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>반납일시</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="returnedAt" value={returnedAt ?? "-"} onChange={handleChange} disabled />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>배차차량</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            value={
                                (contractCar?.manufacturerName ?? "-") +
                                " " +
                                (contractCar?.modelName ?? "") +
                                " " +
                                (contractCar?.modelDetailName ?? "") +
                                " " +
                                (contractCar?.className ?? "") +
                                " " +
                                (contractCar?.trimName ?? "")
                            }
                            onChange={handleChange}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>비고</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <textarea name="memoForTime" placeholder="요청사항입니다." value={memoForTime} onChange={handleChange} disabled />
                    </div>
                </div>
            </div>
        </>
    );
};

const OrderMemberInfo = ({ formData, handleChange, setFormData }) => {
    const { orderCustomer, orderCharge, obtainMember, obtainRentCorp } = formData;

    return (
        <>
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>회원구분</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            value={formData.orderMember?.roles?.map((role) => rolesOptions.find((e) => e.value === role)?.label).join(", ")}
                            disabled
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

const ContractorInfo = ({ formData, handleChange, setFormData }) => {
    const { orderCustomer, orderCharge, obtainMember, obtainRentCorp } = formData;

    return (
        <>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>업체명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" value={obtainRentCorp?.corpName || ""} disabled />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>연락처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" value={obtainMember?.phone || ""} disabled />
                    </div>
                </div>
            </div>
        </>
    );
};

/* 고객 요청사항 */
const EtcInfo = ({ formData, handleChange, setFormData }) => {
    const { memo } = formData;

    return (
        <>
            <div className="item-row" data-grow="1">
                <div className="row-head">
                    <span>비고</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <textarea name="memo" placeholder="비고" value={memo} onChange={handleChange} disabled />
                    </div>
                </div>
            </div>
        </>
    );
};

/* 보험 정보 */
const InsuranceInfo = ({ formData, handleChange, setFormData }) => {
    const { orderInsurance, orderCharge } = formData;

    return (
        <>
            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>보험사</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderInsurance.insuranceCorpName"
                            value={orderInsurance.insuranceCorpName ?? "-"}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>접수번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input type="text" name="orderInsurance.receiptNumber" value={orderInsurance.receiptNumber ?? "-"} disabled />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>예상 과실</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderInsurance.expectFault"
                            value={
                                orderInsurance?.expectFault !== null && orderInsurance?.expectFault !== undefined
                                    ? orderInsurance?.expectFault + "%"
                                    : "-"
                            }
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>예상 수수료</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderInsurance.expectCommission"
                            value={
                                orderInsurance?.expectCommission !== null && orderInsurance?.expectCommission !== undefined
                                    ? orderInsurance?.expectCommission + "%"
                                    : "-"
                            }
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>청구 방식</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="orderInsurance.orderInsurance"
                            value={chargeMethodOptions?.find((e) => e.value === orderInsurance?.chargeMethod)?.label ?? "-"}
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="2">
                <div className="row-head">
                    <span>청구율</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="displacement"
                            value={orderInsurance?.chargeRate ? orderInsurance?.chargeRate + "%" : "-"}
                            disabled
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

// 서비스 항목 추가하기
const PartnersPopup = ({ layer = true, onClose, formData, setFormData }) => {
    useEffect(() => {
        document.body.classList.add("scroll-lock");

        return () => {
            document.body.classList.remove("scroll-lock");
        };
    }, []);

    const handleRegister = () => {
        onClose();
    };

    return ReactDOM.createPortal(
        <>
            <div className={layer ? "layer active" : "layer"} onClick={onClose}></div>

            <div className="popup service-popup">
                <div className="popup-head">
                    <div className="head-tit">
                        <span className="tit-main">사업자 선택</span>
                    </div>
                    <div className="btn-close" onClick={onClose}></div>
                </div>
                <div className="popup-content">
                    <div className="table-container">
                        <div className="table-filter">
                            <div className="filter-row">
                                <div className="filter-item">
                                    <div className="item-content">
                                        <div className="item-input">
                                            <input type="text" placeholder="입력하세요." name="query" />
                                        </div>
                                        <div className="item-buttons">
                                            <button type="button" className="btn-search">
                                                검색
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="table-content">
                            <div className="table-wrapper">
                                <div className="table">
                                    <table>
                                        <colgroup>
                                            <col width={"12%"} />
                                            <col width={"32%"} />
                                            <col width={"17%"} />
                                            <col width={"17%"} />
                                            <col width={"22%"} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">선택</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">사업자명</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">대표자</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">지역</div>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="cell">
                                                        <div className="cell-tit">연락처</div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className="cell">
                                                        <div className="input-checkbox">
                                                            <div className="checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    id="checkAll"
                                                                    name="checkAll"
                                                                    // onChange={(e) => handleChange(e)}
                                                                    // checked={filter.checkAll}
                                                                />
                                                                <label htmlFor=""></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">모빌리카 주식회사</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">박정근</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">서울</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell">
                                                        <div className="cell-desc">010-1234-5678</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="popup-bottom">
                    <button className="btn btn-primary btn-cancel">취소</button>
                    <button className="btn btn-primary btn-confirm">완료</button>
                </div>
            </div>
        </>,
        document.body
    );
};
